<template>
  <div class="d-flex">
    <v-text-field
      v-model="eventNumber"
      @input="onEventNumberChange"
      :rules="[eventNumberRule]"
      :label="eventNumberLabel"
      :min="minEventNumber"
      solo-inverted
      dense
      hide-details
      type="number"
      prepend-icon="mdi-trophy-outline"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: "EventNumberFilter",
  data: () => ({
    eventNumber: "",
    minEventNumber: 1,
  }),
  watch: {
    eventNumberFilterValue(value) {
      this.eventNumber = value;
    },
  },
  computed: {
    eventNumberFilterValue() {
      return this.$store.state.filters.eventNumber.value;
    },
    eventNumberLabel() {
      return this.$t("eventNumber");
    },
  },
  methods: {
    onEventNumberChange() {
      if (parseInt(this.eventNumber) < 0 || parseInt(this.eventNumber) === 0) {
        this.eventNumber = null;
        return;
      }
      
      this.$store.commit("setEventNumber", this.eventNumber);
    },
    eventNumberRule(value) {
      return !(parseInt(value) < 0 || parseInt(value) == 0);
    },
  },
};
</script>
